import React from 'react';
import { Crown, Mail, MessageSquare, Send } from 'lucide-react';
import { useMediaQuery, Box, Typography, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { CustomPaletteColor } from '../../theme';
import { FlexBetween } from '../FlexBetween';
import { SiteLogoProps } from './SiteLogo.types'; // Assuming you have a separate file for types
import { getSiteLogoAccentIconColor, getSiteLogoAccentTextColor, getSiteLogoChannelBorderColor, getSiteLogoChannelIconColors } from './siteLogoTheme';


export const CKSiteLogo: React.FC<SiteLogoProps> = ({ showTagLine = false, tagLine= "", varient }: SiteLogoProps) => {
    let isNonMobile = useMediaQuery('(min-width: 600px)');
    isNonMobile = varient === 'small' ? false : isNonMobile; // Override for small variant
    const theme = useTheme();
    const channelIcons = getSiteLogoChannelIconColors(theme);
    const accentIconColor = getSiteLogoAccentIconColor(theme);
    const accentTextColor = getSiteLogoAccentTextColor(theme, (theme.palette.primary as CustomPaletteColor)[200]);
    const channelBorderColor = getSiteLogoChannelBorderColor(theme);
    return (
        <Box
            sx={{
                padding: varient === 'small' ? '0.9rem' : '0rem',
            }}>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: !isNonMobile ? 'center' : 'flex-start',
                    width: '100%',
                }}>

                {/* Logo Container */}
                <FlexBetween sx={{
                    gap: isNonMobile ? "9.2rem" : '1rem',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    {/* Crown Icon */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'left',
                        marginLeft: '-0.5rem',
                        animation: 'bounce 1s infinite',
                        '@keyframes bounce': {
                            '0%, 100%': { transform: 'translateY(0)' },
                            '50%': { transform: 'translateY(-10px)' },
                        },
                        transition: 'transform 0.3s ease',
                        position: 'relative',
                    }}>
                        <Crown strokeWidth={1.5} width={isNonMobile ? 50: 40} height={isNonMobile ? 50:40} color={accentIconColor} style={{ transform: 'rotate(0deg' }} />
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: isNonMobile ? '1.5rem' : '1rem',
                            border: `2px solid ${channelBorderColor}`,
                            borderRadius: '10%',
                            padding: isNonMobile ? '0.5rem' : '0.25rem',
                            width: '150px',
                        }}>
                        <MessageSquare className="w-10 h-10 sm:w-12 sm:h-12 transform transition-transform duration-300 group-hover:scale-110" strokeWidth={2} color={channelIcons.message} />
                        <Mail className="w-10 h-10 sm:w-12 sm:h-12 transform transition-transform duration-300 group-hover:scale-110" strokeWidth={2} color={channelIcons.mail} />
                        <Send className="w-10 h-10 sm:w-12 sm:h-12 transform transition-transform duration-300 group-hover:scale-110" strokeWidth={2} color={channelIcons.send} />
                    </Box>
                </FlexBetween>
                <Box sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontFamily: 'Poppins, sans-serif' }}>
                    <Typography variant='h1' align='center' sx={{color: (theme.palette.secondary as CustomPaletteColor)[200], fontSize: isNonMobile ? '2.5rem' : '1.5rem', fontWeight: 'bold', textAlign: 'center' }}>
                        Campaign<span style={{ color: accentTextColor }}>King</span>.ai
                    </Typography>
                </Box>

            </Box>
            {
                showTagLine && (
                    <>
                    <Divider sx={{ margin: isNonMobile? '1rem 0': '0.8rem 0', borderColor: (theme.palette.secondary as CustomPaletteColor)[200] }} />
                    <Box sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: isNonMobile ? '1.2rem' : '0.8rem',
                        color: theme.palette.text.secondary,
                    }}>
                        {tagLine}
                    </Box>
                    </>
                )
            }
        </Box>


    );
};
